import { DataRoomShareableLink } from 'models/ShareableLink';
import { createContext } from 'react';
import utils from 'utils';

type EditShareableLinkContextProps = {
  openEditShareableLink: (link: DataRoomShareableLink) => void;
  openFilesSelectForLink: (
    link: DataRoomShareableLink,
    onSuccessFn?: (link: DataRoomShareableLink) => void,
  ) => void;
};

export default createContext<Partial<EditShareableLinkContextProps>>({
  openEditShareableLink: utils.noop,
});
